module.exports = __webpack_public_path__ + "static/media/logotypy_partnerow.398f08f2.png";